import { render } from "./PublisherPage.vue?vue&type=template&id=7806ef89&scoped=true"
import script from "./PublisherPage.vue?vue&type=script&lang=js"
export * from "./PublisherPage.vue?vue&type=script&lang=js"

import "./PublisherPage.vue?vue&type=style&index=0&id=7806ef89&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7806ef89"]])

export default __exports__